import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Grid, Button,  Input } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function StatusMaster(props) {
    const [StatusCode, setStatusCode] = useState([]);
    const [StatusDesc, setStatusDesc] = useState('');
    const [UserId, setUserId] = useState('');
  
    const [units, setUnits] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    
    const [formMode, setFormMode] = useState('add');
    const [editCasteId, setEditCasteCode] = useState(null);
    const [showGrid, setShowGrid] = useState(true);
    const [StatusMasterEntries, setStatusMasterEntries] = useState([]); 
  
   const [deleteEntryNo, setDeleteEntryNo] = useState(null);
      const [openConfirmation, setOpenConfirmation] = useState(false); 

    useEffect(() => {
      fetchStatusMaster();
    }, []);
  
    const fetchStatusMaster = async () => {
      try {
        const response = await axios.get('https://www.wingap.net.in/api/status');
        setStatusMasterEntries(response.data);
        const maxEntryNo = calculateMaxEntryNo(response.data);
        const nextEntryNo = maxEntryNo + 1; 
        setStatusCode (nextEntryNo);
        console.log(response.data);
      } catch (error) {
        console.log('error:', error);
      }
    };
  
    
      const calculateMaxEntryNo = (entries) => {
          let maxEntryNo = 0;
          for (const entry of entries) {
              if (entry.StatusCode > maxEntryNo) {
                  maxEntryNo = entry.StatusCode;
              }
          }
          return maxEntryNo;
      };
  
    const addStatus = async () => {
      try {
        await axios.post('https://www.wingap.net.in/api/status', {
          StatusCode: StatusCode,
          StatusDesc: StatusDesc,
          UserID: props.name,
        });
        fetchStatusMaster();
        setStatusCode('');
        setStatusDesc('');
        setUserId('');
      } catch (error) {
        console.log('Error:', error);
      }
    };
  
    const updateStatus = async (StatusCode) => {
      try {
        await axios.put(`https://www.wingap.net.in/api/status/${StatusCode}`, {
          StatusCode: StatusCode,
          StatusDesc: StatusDesc,
          UserID: props.name,
        });
        fetchStatusMaster();
        setStatusCode('');
        setStatusDesc('');
        setUserId('');
        setFormMode('add');
      } catch (error) {
        console.log('Error:', error);
      }
    }; 
  
      const handleDeleteConfirmation = async () => {
        try {
          if (deleteEntryNo) {
            await deleteStatus(deleteEntryNo.StatusCode);
            setOpenConfirmation(false);
          }
        } catch (error) {
          console.log('Error:', error);
        }
      };

    const deleteStatus = async (StatusCode) => {
      try {
        const response = await axios.delete(`https://www.wingap.net.in/api/status/${StatusCode}`, {
          headers: {
            'username': props.name,
          },
        });
        if (response.status === 200) {
          fetchStatusMaster();
        }
      } catch (error) {
        console.log('Error:', error);
  
        if (error.response && error.response.status === 403) {
          // User does not have permission to delete account group
          setErrorMessage('Permission Denied');
          setSnackbarOpen(true);
        } else {
          // Handle other errors if needed
          setErrorMessage('An error occurred while deleting the account group. Please try again later.');
          setSnackbarOpen(true);
          // Alternatively, you can log the detailed error to the console for debugging
          console.error('Error:', error);
        }
      }
    };
  
    const handleCloseSnackbar = () => {
      // Close the Snackbar
      setSnackbarOpen(false);
      // Reset the error message
      setErrorMessage('');
    };
  
    const setEditForm = (room) => {
      setFormMode('edit');
      setStatusCode(room.StatusCode);
      setStatusDesc(room.StatusDesc);
      setUserId(room.UserID);
      setShowGrid(false);
    };
  
    /* const handleSearch = (searchQuery) => {
      const filtered = units.filter((unit) => {
        const UnitId = unit.UnitId.toString().toLowerCase();
        const UnitName = unit.UnitName.toString().toLowerCase();
        const DeptCode = unit.DeptCode.toString().toLowerCase();
        const YearCode = unit.YearCode.toString().toLowerCase();
        const UserID = unit.UserID.toString().toLowerCase();
  
        return (
          UnitId.includes(searchQuery.toLowerCase()) ||
          UnitName.includes(searchQuery.toLowerCase()) ||
          DeptCode.includes(searchQuery.toLowerCase()) ||
          YearCode.includes(searchQuery.toLowerCase()) ||
          UserID.includes(searchQuery.toLowerCase())
        );
      });
  
      setCasteMasterEntries(filtered);
    };
  
    useEffect(() => {
      handleSearch(props.searchQuery);
    }, [props.searchQuery, units]);*/
  
    const handleshowandhide = () => {
      setShowGrid(!showGrid);
      setUnits(units);
    };
  
    const handleCancel = () => {
      setFormMode('add');
      setEditCasteCode('');
      setStatusCode('');
      setStatusDesc('');
      setUserId('');
    };
  
    const componentPDF = useRef();
  
    const generatePDF = useReactToPrint({
      content: () => componentPDF.current,
      documentTitle: "Status Data",
      onAfterPrint: () => alert("Pdf downloaded"),
      pageStyle: `
        @media print {
          .print-hide {
            display: none;
          }
  
          table th.print-hide,
          table td.print-hide {
            border: none;
          }
        }
      `,
    });
  

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Status Master</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>
          {formMode === 'add' ? 'Add' : 'Edit'}
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="StatusCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              StatusCode
            </label>
            <input
              type="text"
              value={StatusCode}
              readOnly
              placeholder="StatusCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="StatusDesc" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              StatusDesc
            </label>
            <input
              type="text"
              value={StatusDesc}
              onChange={(e) => setStatusDesc(e.target.value)}
              placeholder="StatusDesc"
              style={{ marginBottom: '5px', padding: '5px', width: '20%' }}
            />
          </div>
          
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="UserID" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              UserID
            </label>
            <input
              type="text"
              value={UserId}
              readOnly
              onChange={(e) => setUserId(e.target.value)}
              placeholder="UserID"
              style={{ marginBottom: '5px', padding: '5px', width: '60%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addStatus : () => updateStatus(StatusCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
        
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  StatusCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  StatusDesc 
                </th>
                
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  UserID
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {StatusMasterEntries.map((status) => (
                <tr key={status.StatusCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{status.StatusCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{status.StatusDesc}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{status.UserID}</td>

                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(status)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setDeleteEntryNo({StatusCode: status.StatusCode});
                        setOpenConfirmation(true); 
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
    </div>
  );
}
export default StatusMaster;
